// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__1GE9J","list":"Sidebar_list__4nsUm","item":"Sidebar_item__UxC8B"};